
import { Link } from "react-router-dom";
import GulfStudentsData from "../Data/Gulf_Students/GulfStudentsData";
import "../Gulf_Students/CSS/GulfStudentsCSS.css";
import "../Gulf_Students/CSS/ThanksPage.css";
import PdfFile from "../lorem-ipsum.pdf";

const PeerMentorshipSuccess = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = PdfFile;
    link.download = "lorem-ipsum.pdf";
    link.click();
  };
  return (
    <>
      <section className="thank-you-page-main-section">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 thank-you-page-heading-para-div">
              <h1>Thank you for submitting the request. You’re In!</h1>
              <button onClick={handleDownload}>Download It Now</button>
              <h2>Next step: Join our private WhatsApp community and meet your mentor.</h2>
              <Link to={"/gulf-students/career-prep"}><button>Join the Community</button></Link>
            </div>
          </div>
        </div>
      </section>
      <section className="other-services-section-start-here">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 other-services-heading-div">
              <h2>Other <span>Services</span></h2>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
            {
              GulfStudentsData.filter(item => item.id !== 3)
                .map((item) => {
                  return (
                    <div className="col our-services-card-div" key={item.id}>
                      <div className="our-services-card-inner-div">
                        <div className="what-we-offer-card-icon">
                          <img src={item.bannerImg} alt="" />
                        </div>
                        <h5>{item.heading}</h5>
                        <p>{item.text}</p>
                        {item.link}
                      </div>
                    </div>
                  )
                })
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default PeerMentorshipSuccess